<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1765_2338)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.25 3.375C5.25 3.78921 5.58579 4.125 6 4.125C6.41421 4.125 6.75 3.78921 6.75 3.375C6.75 2.96079 6.41421 2.625 6 2.625C5.58579 2.625 5.25 2.96079 5.25 3.375ZM6.75 8.625V5.625C6.75 5.21079 6.41421 4.875 6 4.875C5.58579 4.875 5.25 5.21079 5.25 5.625V8.625C5.25 9.03921 5.58579 9.375 6 9.375C6.41421 9.375 6.75 9.03921 6.75 8.625Z"
        :fill="variant === 'light' ? 'white' : '#868D9C'"
      />
    </g>
    <defs>
      <clipPath id="clip0_1765_2338">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  variant: {
    type: String as PropType<"light" | "dark">,
    default: "light",
  },
});
</script>
